export class UnauthorizedError extends Error {
  code: number;

  constructor(message: string) {
    super(message);
    this.message = "Unauthorized";
    this.code = 401;
  }
}
